document.addEventListener('DOMContentLoaded', function () {
    // =============================================
    // INDEX PAGE: Search and filter functionality
    // =============================================
    const searchInput = document.getElementById('guide-search');
    if (searchInput) {
        const clearSearchBtn = document.getElementById('clear-search');
        const categoryFilters = document.querySelectorAll('.category-filter');
        const guideItems = document.querySelectorAll('.guide-item');
        const guidesCount = document.getElementById('guides-count');
        const noResults = document.getElementById('no-results');
        const resetFiltersBtn = document.getElementById('reset-filters');

        let currentCategory = 'all';
        let currentSearch = '';

        // Check URL for category parameter
        const urlParams = new URLSearchParams(window.location.search);
        const categoryParam = urlParams.get('category');
        if (categoryParam) {
            const targetButton = document.querySelector(`.category-filter[data-category="${categoryParam}"]`);
            if (targetButton) {
                categoryFilters.forEach(b => b.classList.remove('active'));
                targetButton.classList.add('active');
                currentCategory = categoryParam;
            }
        }

        // Filter guides
        function filterGuides() {
            let visibleCount = 0;

            guideItems.forEach(item => {
                const category = item.dataset.category;
                const category2 = item.dataset.categorytwo;
                const title = item.dataset.title;
                const description = item.dataset.description;
                const keywords = item.dataset.keywords;

                const matchesCategory = currentCategory === 'all' || category === currentCategory || category2 === currentCategory;
                const matchesSearch = currentSearch === '' ||
                    title.includes(currentSearch) ||
                    description.includes(currentSearch) ||
                    keywords.includes(currentSearch);

                if (matchesCategory && matchesSearch) {
                    item.classList.remove('hidden');
                    visibleCount++;
                } else {
                    item.classList.add('hidden');
                }
            });

            // Update count
            guidesCount.textContent = visibleCount;

            // Show/hide no results message
            if (visibleCount === 0) {
                noResults.style.display = 'block';
            } else {
                noResults.style.display = 'none';
            }
        }

        // Category filter click
        categoryFilters.forEach(btn => {
            btn.addEventListener('click', function () {
                categoryFilters.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                currentCategory = this.dataset.category;
                filterGuides();
            });
        });

        // Search input
        searchInput.addEventListener('input', function () {
            currentSearch = this.value.toLowerCase().trim();
            clearSearchBtn.style.display = currentSearch ? 'block' : 'none';
            filterGuides();
        });

        // Clear search
        clearSearchBtn.addEventListener('click', function () {
            searchInput.value = '';
            currentSearch = '';
            clearSearchBtn.style.display = 'none';
            filterGuides();
            searchInput.focus();
        });

        // Reset all filters
        resetFiltersBtn.addEventListener('click', function () {
            searchInput.value = '';
            currentSearch = '';
            currentCategory = 'all';
            clearSearchBtn.style.display = 'none';

            categoryFilters.forEach(btn => {
                btn.classList.remove('active');
                if (btn.dataset.category === 'all') {
                    btn.classList.add('active');
                }
            });

            filterGuides();
        });

        // Keyboard shortcut: Escape to clear search
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && document.activeElement === searchInput) {
                clearSearchBtn.click();
            }
        });

        // Apply initial filter (for URL parameter support)
        filterGuides();
    }

    // =============================================
    // SHOW PAGE: Scroll Progress Bar
    // =============================================
    const progressBar = document.getElementById('guide-progress-bar');
    const progressContainer = progressBar ? progressBar.parentElement : null;

    if (progressBar && progressContainer) {
        const guideContent = document.getElementById('guide-content');

        function updateProgressBar() {
            if (!guideContent) return;

            const contentRect = guideContent.getBoundingClientRect();
            const contentTop = guideContent.offsetTop;
            const contentHeight = guideContent.offsetHeight;
            const windowHeight = window.innerHeight;
            const scrollY = window.scrollY;

            // Calculate progress based on how much of the content has been scrolled
            const startPoint = contentTop - windowHeight;
            const endPoint = contentTop + contentHeight - windowHeight;
            const scrollRange = endPoint - startPoint;

            let progress = 0;
            if (scrollY > startPoint) {
                progress = ((scrollY - startPoint) / scrollRange) * 100;
                progress = Math.min(Math.max(progress, 0), 100);
            }

            progressBar.style.width = progress + '%';

            // Show/hide progress bar based on scroll position
            if (scrollY > 100) {
                progressContainer.classList.add('visible');
            } else {
                progressContainer.classList.remove('visible');
            }
        }

        // Initial update
        updateProgressBar();

        // Update on scroll
        window.addEventListener('scroll', updateProgressBar, { passive: true });

        // Update on resize
        window.addEventListener('resize', updateProgressBar, { passive: true });
    }

    // =============================================
    // SHOW PAGE: Table of Contents generation
    // =============================================
    const tocNav = document.getElementById('toc-nav');
    if (tocNav) {
        const content = document.getElementById('guide-content');
        const headings = content.querySelectorAll('h2');

        headings.forEach((heading, index) => {
            // Add ID to heading for anchor links
            const id = 'section-' + (index + 1);
            heading.id = id;

            // Create TOC link
            const link = document.createElement('a');
            link.href = '#' + id;
            link.textContent = heading.textContent.replace(/^\d+\.\s*/, '');
            tocNav.appendChild(link);

            // Smooth scroll on click
            link.addEventListener('click', function (e) {
                e.preventDefault();
                heading.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });

        // Highlight active section on scroll
        const tocLinks = tocNav.querySelectorAll('a');

        function updateActiveLink() {
            let currentSection = '';

            headings.forEach((heading) => {
                const rect = heading.getBoundingClientRect();
                if (rect.top <= 150) {
                    currentSection = heading.id;
                }
            });

            tocLinks.forEach((link) => {
                link.classList.remove('active');
                if (link.getAttribute('href') === '#' + currentSection) {
                    link.classList.add('active');
                }
            });
        }

        // Initial check
        updateActiveLink();

        // Update on scroll
        window.addEventListener('scroll', updateActiveLink, {
            passive: true
        });
    }
});
